import $ from "jquery";
import uly from "ulysses/core";
import ko from "knockout";
import HalResource from "ulysses/api";
import Globalize from "globalize";
import "ulysses/controls/datatable";

var _ocurrency_f = uly.formatters.currency;
uly.Globalize = Globalize;
ko.extenders.numeric = function (target, precision) {
    //create a writable computed observable to intercept writes to our observable
    var result = ko.pureComputed({
        read: function() {
            return Globalize.format(target(), "N");
        },
        write: function (newValue) {
            var newValueAsNum = 0;
            var current = target(),
                roundingMultiplier = Math.pow(10, precision);
            if (typeof newValue == "number") {
                newValueAsNum = isNaN(newValue) ? 0 : +newValue;
            } else {
                try {
                    newValueAsNum = Globalize.parseFloat(newValue);
                } 
                catch(e) {
                    newValueAsNum = isNaN(newValue) ? 0 : +newValue;
                }
            }
            var valueToWrite = Math.round(newValueAsNum * roundingMultiplier) / roundingMultiplier;

            //only write if it changed
            if (valueToWrite !== current) {
                target(valueToWrite);
            } else {
                //if the rounded value is the same, but a different value was written, force a notification for the current field
                if (newValue !== current) {
                    target.notifySubscribers(valueToWrite);
                }
            }
        }
    }).extend({
        notify: 'always'
    });

    //initialize with current value to make sure it is rounded appropriately
    result(target());

    //return the new computed observable
    return result;
};

uly.formatters.currency = function currency_formatter(data, type, row) {
    if (data) {
        if (!Object.isObject(data))
            return _ocurrency_f(data, type, row);


        return data;
    }
    return data;
};

uly.formatters.money = function (data, type, row) {
    if (data) {
        if (data.formatted)
            return data.formatted;
        if (type === 'display' || type === 'filter') {
            return Globalize.format(data.native, "c");
        }
        return data.native;
    }
    return data;
};

uly.currency = {
    show_native: ko.observable(false)
};

function buildCurrencyModel(observable) {
    var money = observable() || {};
    var currency = ko.unwrap(money.currency) || {};
    var childmodel = {
        "foreign": ko.observable(ko.unwrap(money.foreign)).extend({ numeric: 2 }),
        "native": ko.observable(ko.unwrap(money.native)).extend({ numeric: 2 }),
        "rate": ko.observable(ko.unwrap(money.rate)),
        "currency": {
            "current_rate": ko.observable(ko.unwrap(currency.current_rate)),
            "currency_code": ko.observable(ko.unwrap(currency.currency_code)),
            "name": ko.observable(ko.unwrap(currency.name))
        },
        "currency_id": ko.observable(ko.unwrap(money.currency_id)),
        "updating": ko.observable(false)
    };

    childmodel.foreign.subscribe(function (newvalue) {
        var money = observable() || {};
        if (typeof newvalue !== "number") {
            newvalue = Globalize.parseFloat(newvalue);
        }

        if (ko.isObservable(money.foreign)) {
            money.foreign(1.0 * (newvalue || 0.0));
        } else {
            money.foreign = 1.0 * (newvalue || 0.0);
        }
        if (childmodel.updating.peek()) {
            return;
        }
        childmodel.updating(true);
        try {
            var rate = childmodel.rate();
            if (rate === 0) {
                rate = 1.0;
            }
            childmodel.native(Math.roundMoney(newvalue / rate));
        } finally {
            childmodel.updating(false);
        }
    });
    childmodel.native.subscribe(function (newvalue) {
        var money = observable() || {};
        if (typeof newvalue !== "number") {
            newvalue = Globalize.parseFloat(newvalue);
        }
        if (ko.isObservable(money.native)) {
            money.native(1.0 * (newvalue || 0.0));
        } else {
            money.native = 1.0 * (newvalue || 0.0);
        }
        if (childmodel.updating.peek()) {
            return;
        }
        childmodel.updating(true);
        try {
            var rate = 1.0 * (childmodel.rate() || 0.0);
            if (rate === 0)
                rate = 1.0;
            childmodel.foreign(Math.roundMoney(newvalue * rate));
        } finally {
            childmodel.updating(false);
        }
    });
    childmodel.rate.subscribe(function (newvalue) {
        var money = observable() || {};
        if (ko.isObservable(money.rate)) {
            money.rate(1.0 * (newvalue || 0.0));
        } else {
            money.rate = (1.0 * newvalue) || 0.0;
        }
        if (childmodel.updating.peek()) {
            return;
        }
        childmodel.updating(true);
        try {
            var rate = newvalue;
            childmodel.foreign(Math.roundMoney(childmodel.native() * rate));
        } finally {
            childmodel.updating(false);
        }
    });
    childmodel.currency_id.subscribe(function (newvalue) {
        var money = observable() || {};
        var updating = childmodel.updating.peek();
        childmodel.updating(true);
        try {
            if (ko.isObservable(money.currency_id)) {
                money.currency_id(newvalue);
            } else {
                money.currency_id = newvalue;
            }
        } finally {
            childmodel.updating(updating);
        }
        //need to fetch current rate from server
        if (childmodel.updating.peek()) {
            return;
        }
        childmodel.updating(true);
        uly.api.start().follow("uly:data").follow("uly:currency", {
            "nodata": 1
        }).follow("find", {
            "rel": newvalue,
            "fields": ["current_rate_value", "currency_code", "name"]
        }).done(function (result) {
            childmodel.rate(result.current_rate_value || 1.0);
            childmodel.foreign(Math.roundMoney(childmodel.native() * childmodel.rate()));
            childmodel.currency.current_rate(childmodel.rate());
            childmodel.currency.currency_code(result.currency_code);
            childmodel.currency.name(result.name);
            if (money.currency) {
                if (ko.isObservable(money.currency.current_rate)) {
                    money.currency.current_rate(childmodel.rate());
                }
                if (ko.isObservable(money.currency.currency_code)) {
                    money.currency.currency_code(result.currency_code);
                }
                if (ko.isObservable(money.currency.name)) {
                    money.currency.name(result.name);
                }
            }
        }).always(function () {
            childmodel.updating(false);
        });
    });
    return childmodel;
}

ko.bindingHandlers.currency = {
    init: function (elt, va, allbindings, model, context) {
        var childmodel = buildCurrencyModel(function () {
            return ko.unwrap(va());
        });
        var driver = allbindings().currencydriver;
        if (driver && ko.isObservable(driver)) {
            driver.subscribe(function (newvalue) {
                var newcid = ko.unwrap(driver());
                if (childmodel.updating()) {
                    return;
                }
                if (newcid && newcid !== ko.unwrap(childmodel.currency_id())) {
                    childmodel.currency_id(newcid);
                    return;
                }
            });
        }

        $(elt).data("_currency", childmodel);
        var cc = context.createChildContext(childmodel);
        ko.applyBindingsToDescendants(cc, elt);
        return {
            "controlsDescendantBindings": true
        };
    },
    update: function (elt, va, allbindings, model, context) {
        var money = ko.toJS(ko.unwrap(va())) || {};
        var childmodel = $(elt).data("_currency");
        if (childmodel.updating.peek()) {
            return;
        }
        if (money) {
            var currency = ko.unwrap(money.currency);
            childmodel.updating(true);
            try {
                childmodel.foreign(money.foreign);
                childmodel.native(money.native);
                childmodel.rate(money.rate);
                if (currency) {
                    childmodel.currency.current_rate(ko.unwrap(currency.current_rate));
                    childmodel.currency.currency_code(ko.unwrap(currency.currency_code));
                    childmodel.currency.name(ko.unwrap(currency.name));
                    console.error("setting currency to:", money.currency_id);
                    childmodel.currency_id(money.currency_id);
                }
            } finally {
                childmodel.updating(false);
            }
            if (!currency) {
                //convert to currency and refetch
                console.error("forcing currency to:", money.currency_id);
                childmodel.currency_id(money.currency_id);
            }
        }
    }
};